import { StatusCarte } from '@/enum/StatusCarte';
import { StatusCommande } from '@/enum/StatusCommande';
import Vue from 'vue'

export const colorStatusCarte = (value: number) => {    
    switch(value){
        case StatusCarte.valide: return "#A6F562";
        case StatusCarte.complet: return "#E758F5";
        case StatusCarte.perime: return "#F57F65";
    }
    return "";     
}
Vue.filter('colorStatusCarte', colorStatusCarte)